module.exports = __webpack_public_path__ + "static/media/picto-collapse.ee94b4d8.png";